import { actionTypes, TrabajosActions, TrabajosState, TrabajosStatus, initialState } from './types'

const TrabajosReducer = (state: TrabajosState = initialState, action?: TrabajosActions): TrabajosState => {
  switch (action?.type) {
    case actionTypes.TRABAJOS_FETCH:
      return {
        ...state,
        status: TrabajosStatus.Loading,
      }
    case actionTypes.TRABAJOS_SUCCESS:
      return {
        ...state,
        status: TrabajosStatus.Success,
        trabajos: action?.payload?.trabajos,
      }
    case actionTypes.TRABAJOS_ERROR:
      return {
        ...state,
        status: TrabajosStatus.Error,
      }
    case actionTypes.TRABAJOS_RESET:
      return {
        ...state,
        status: TrabajosStatus.Idle,
      }
    default:
      return state
  }
}

export default TrabajosReducer
